export default "__VITE_ASSET__EeLwMpOi__"